export const PAGE = {
    TITLE: 'Review products',
    DESCRIPTION1_COMMON:
        "Review the selected set of products below. If you'd prefer to advertise other products, click 'Back' to change the campaign type.",
    DESCRIPTION1_SPECIFIC_PRODUCTS:
        'As a specific-product campaign, you can choose the exact products you want to advertise to this campaign. Select the products you want to advertise below.',
    DESCRIPTION2:
        'Note: products in the following categories cannot be advertised: adult, nudity, weapons, violence, alcohol, tobacco, drugs, or other sensitive content.'
};
